// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2FOPq","title":"ClientReferral_title__2aWwS","itemText":"ClientReferral_itemText__3uG76"};